'use client'
import classNames from 'classnames'
import { motion, MotionProps } from 'framer-motion'
import React, { ReactNode } from 'react'

interface CardProps extends MotionProps {
  tag?: 'section' | 'article' | 'div'
  className?: string
  id?: string
  children: ReactNode
  onClick?: () => void
  testid?: string
  direction?: 'row' | 'column'
}

const Card: React.FC<CardProps> = ({ className, children, id, onClick, testid, direction = 'column', tag = 'div', ...props }) => {
  const CardTag = tag
  const MotionCardTag = motion.create(CardTag)
  return (
    <MotionCardTag
      data-testid={testid}
      className={classNames(`flex`, 'rounded-3xl', { 'cursor-pointer': !!onClick, 'flex-col': direction === 'column', 'flex-row': direction === 'row' }, className)}
      id={id}
      onClick={onClick}
      {...props}
    >
      {children}
    </MotionCardTag>
  )
}

export default Card
